// extracted by mini-css-extract-plugin
module.exports = {"container":"Tags_container__2C_YJ","focus":"Tags_focus__2_upM","disabled":"Tags_disabled__1YHNJ","tags":"Tags_tags__1Z1fp"};